import { WebHomeControl } from 'pages/web-home/WebHomeControl'
import { Icons } from '@pankod/refine-antd'
import { ResourceProps } from '@pankod/refine-core'
import { AddressesList, BannerList, CmsCategoryList, CodesList, configurator, IgicTypeCreate, IgicTypeList, IslandCreate, IslandEdit, IslandList, IslandShow, IssueList, IssueShow, itemCategories, LogsList, MarketplaceCategoriesList, MarketplaceList, OrderList, OrderShow, PaymentMethodsCreate, PaymentMethodsList, PromoList, PurchaseList, SalesList, ShipmentEdit, ShipmentMethodsList, ShipmentsList, SupplierList, UserCreate, UserEdit, UserList, UserShow, VariablesList } from 'pages'
import { CompanyOrderList, CompanyOrderShow } from 'pages/company_order'
import { CorrectionsList } from 'pages/corrections'
import { EmployeeList } from 'pages/employees'
import { OrderLiveList } from 'pages/ordersLive'
import { ProfileShow } from 'pages/profile'
import { SimpleJornada } from 'pages/profile/SimpleJornada'
import { RefundsList } from 'pages/refunds'
import { Reports } from 'pages/reports'
import { RequestOrdersTable } from 'pages/requestedOrders'
import { SellerList } from 'pages/sellers'
import { SubscribersList } from 'pages/subscribers/list'
import { ADMIN_ROLE_ID, DASHBOARD_REPORTING_USER_ROLE, WAREHOUSE_ROLE_ID } from 'utility/constants'
import { supabaseClient } from 'utility/supabaseClient'

export const resources: ResourceProps[] = [
  {
    name: 'ordersLive',
    list: OrderLiveList,
    show: OrderShow,
    icon: <Icons.ShoppingCartOutlined />
  },
  {
    name: 'requestOrders',
    list: RequestOrdersTable,
    show: OrderShow,
    icon: <Icons.ShoppingCartOutlined />
  },
  {
    name: 'orders',
    list: OrderList,
    show: OrderShow,
    icon: <Icons.DatabaseOutlined />
  },
  {
    options: {
      label: 'company_order',
      route: 'company_order'
    },
    name: 'company_order',
    list: CompanyOrderList,
    show: CompanyOrderShow,
    icon: <Icons.ReconciliationOutlined />
  },
  {
    name: 'issues',
    list: IssueList,
    show: IssueShow,
    icon: <Icons.IssuesCloseOutlined />
  },
  {
    name: 'shipments',
    list: ShipmentsList,
    edit: ShipmentEdit,
    icon: <Icons.ReconciliationOutlined />
  },
  {
    name: 'Ventas',
    list: SalesList,
    icon: <Icons.EuroCircleFilled />
  },
  {
    name: 'sales',
    parentName: 'Ventas',
    options: { label: 'sales', route: 'sales' },
    list: SalesList,
    icon: <Icons.UndoOutlined />
  },
  {
    name: 'refunds',
    parentName: 'Ventas',
    options: { label: 'refunds', route: 'refunds' },
    list: RefundsList,
    icon: <Icons.UndoOutlined />
  },
  {
    name: 'corrections',
    parentName: 'Ventas',
    options: { label: 'corrections', route: 'corrections' },
    list: CorrectionsList,
    icon: <Icons.UndoOutlined />
  },
  {
    options: {
      label: 'purchases',
      route: 'purchases'
    },
    name: 'market_orders',
    list: PurchaseList,
    icon: <Icons.ShoppingOutlined />
  },
  // {
  //   name: 'invoices_matchings',
  //   list: InvoicesMatchingsList,
  //   icon: <Icons.InboxOutlined />
  // },
  {
    name: 'reports',
    list: Reports,
    icon: <Icons.BarChartOutlined />
  },
  {
    name: 'Tiendas',
    icon: <Icons.ShopOutlined />
  },
  {
    name: 'marketplaces',
    parentName: 'Tiendas',
    options: { label: 'marketplaces', route: 'marketplaces' },
    list: MarketplaceList,
    icon: <Icons.ShopOutlined />
  },
  {
    name: 'marketplace_categories',
    parentName: 'Tiendas',
    options: { label: 'marketplace_categories', route: 'marketplace_categories' },
    list: MarketplaceCategoriesList,
    icon: <Icons.FolderOutlined />
  },
  {
    name: 'suppliers',
    parentName: 'Tiendas',
    options: { label: 'suppliers', route: 'suppliers' },
    list: SupplierList,
    icon: <Icons.BoxPlotOutlined />
  },
  {
    name: 'sellers',
    parentName: 'Tiendas',
    options: { label: 'sellers', route: 'sellers' },
    list: SellerList,
    icon: <Icons.ShoppingOutlined />
  },
  {
    name: 'Usuarios',
    icon: <Icons.UserOutlined />
  },
  {
    name: 'users',
    parentName: 'Usuarios',
    options: { label: 'users', route: 'users' },
    list: UserList,
    create: UserCreate,
    edit: UserEdit,
    show: UserShow,
    icon: <Icons.UserOutlined />
  },
  {
    name: 'employees',
    parentName: 'Usuarios',
    options: { label: 'employees', route: 'employees' },
    list: EmployeeList,
    icon: <Icons.TeamOutlined />
  },
  {
    name: 'addresses',
    parentName: 'Usuarios',
    options: { label: 'addresses', route: 'addresses' },
    list: AddressesList,
    icon: <Icons.HomeOutlined />
  },
  {
    name: 'subscribers',
    parentName: 'Usuarios',
    options: { label: 'subscribers', route: 'subscribers' },
    list: SubscribersList,
    icon: <Icons.LikeOutlined />
  },
  {
    name: 'Personalizaciones',
    icon: <Icons.BgColorsOutlined />
  },
  {
    name: 'web_home',
    parentName: 'Personalizaciones',
    options: { label: 'Home web', route: 'web-home' },
    list: WebHomeControl,
    icon: <Icons.HomeOutlined />
  },
  {
    name: 'configurator',
    parentName: 'Personalizaciones',
    options: { label: 'configurator', route: 'configurator' },
    list: configurator,
    icon: <Icons.MobileOutlined />
  },
  {
    name: 'banners',
    parentName: 'Personalizaciones',
    options: { label: 'banners', route: 'banners' },
    list: BannerList,
    icon: <Icons.FileImageOutlined />
  },
  {
    name: 'cms_categories',
    parentName: 'Personalizaciones',
    options: { label: 'cms_categories', route: 'cms_categories' },
    list: CmsCategoryList
  },
  {
    name: 'Configuraciones',
    icon: <Icons.ToolOutlined />
  },
  {
    name: 'islands',
    parentName: 'Configuraciones',
    options: { label: 'islands', route: 'islands' },
    list: IslandList,
    create: IslandCreate,
    edit: IslandEdit,
    show: IslandShow,
    icon: <Icons.EnvironmentOutlined />
  },
  {
    name: 'payment_methods',
    parentName: 'Configuraciones',
    options: { label: 'payment_methods', route: 'payment_methods' },
    list: PaymentMethodsList,
    create: PaymentMethodsCreate,
    icon: <Icons.CreditCardOutlined />
  },
  {
    name: 'shipment_methods',
    parentName: 'Configuraciones',
    options: { label: 'shipment_methods', route: 'shipment_methods' },
    list: ShipmentMethodsList,
    icon: <Icons.RocketOutlined />
  },
  {
    name: 'igic_types',
    parentName: 'Configuraciones',
    options: { label: 'igic_types', route: 'igic_types' },
    list: IgicTypeList,
    create: IgicTypeCreate,
    icon: <Icons.PayCircleOutlined />
  },
  {
    name: 'item_categories',
    parentName: 'Configuraciones',
    options: { label: 'item_categories', route: 'item_categories' },
    list: itemCategories,
    icon: <Icons.CalculatorOutlined/>
  },
  {
    name: 'codes',
    parentName: 'Configuraciones',
    options: { label: 'codes', route: 'codes' },
    list: CodesList,
    icon: <Icons.BarcodeOutlined />
  },
  {
    name: 'promo',
    parentName: 'Configuraciones',
    options: { label: 'promo', route: 'promo' },
    list: PromoList,
    icon: <Icons.QrcodeOutlined />
  },
  {
    name: 'variables',
    parentName: 'Configuraciones',
    options: { label: 'variables', route: 'variables' },
    list: VariablesList,
    icon: <Icons.GlobalOutlined />
  },
  {
    name: 'logs',
    list: LogsList,
    icon: <Icons.AlignLeftOutlined />
  },
  {
    name: 'jornada',
    list: SimpleJornada,
    icon: <Icons.ClockCircleOutlined />
  },
  {
    name: 'profile',
    show: ProfileShow,
    options: { label: 'variables', route: 'profile' }
  }
]

export const grantedResources = ():ResourceProps[] => {
  const role = supabaseClient.auth.user()?.user_metadata?.role_id

  let granted = resources.filter(r => r.name !== 'web_home' || role === ADMIN_ROLE_ID)
  if (role === DASHBOARD_REPORTING_USER_ROLE) granted = granted.filter(r => r.name === 'reports')
  else if (role === WAREHOUSE_ROLE_ID) granted = granted.filter(r => ['orders', 'shipments', 'issues', 'jornada'].includes(r.name))
  else if (role !== ADMIN_ROLE_ID) granted = granted.filter(r => r.name !== 'reports').filter(r => r.name !== 'employees').filter(r => r.name !== 'jornada')
  else granted = granted.filter(r => r.name !== 'jornada')

  return granted
}
